var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ai-chatbot-iframe-container"},[(!_vm.hasError)?_c('iframe',{key:_vm.src,ref:"iframe",attrs:{"src":_vm.src,"title":"AI Chatbot Iframe"},on:{"load":_vm.onLoad,"error":_vm.onError}}):_vm._e(),(_vm.hasError)?_c(_vm.errorComponent,{tag:"component",on:{"refresh":_vm.refresh}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }